import { BillingPeriodUnit } from '../../../../contracts';

const BILLING_PERIOD_UNIT_TO_TEXT_MAP: Record<BillingPeriodUnit, string> = {
  [BillingPeriodUnit.MONTHLY]: 'monthly',
  [BillingPeriodUnit.YEARLY]: 'yearly',
  [BillingPeriodUnit.WEEKLY]: 'weekly',
  [BillingPeriodUnit.DAILY]: 'daily',
};

export function subscriptionUnitToText(unit: BillingPeriodUnit | undefined) {
  return unit ? BILLING_PERIOD_UNIT_TO_TEXT_MAP[unit] : '';
}
